import React, { useEffect } from "react";
import { useState } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Offcanvas from "react-bootstrap/Offcanvas";
import logo from "../../assets/images/logo.png";
import { useLocation } from "react-router-dom";
import profileImg from "../../assets/images/profileImg.png";
import { IoLogOutOutline } from "react-icons/io5";
import "./Header.css";

export const Header = () => {
  const location = useLocation();
  const pathName = location.pathname;
  // Add state to control offcanvas visibility
  const [show, setShow] = useState(false);
  const [activeMenu, setActiveMenu] = useState(pathName || "/");
  useEffect(() => {
    setActiveMenu(pathName);
  }, [pathName]);
  // Handlers for closing and toggling the sidebar
  const handleClose = () => setShow(false);
  const handleToggle = () => setShow(!show);
  return (
    <Navbar expand="lg" className="headerContainer" sticky="top">
      <Container className="navContainer">
        {/* Update the toggle to use your custom handler */}
        <Navbar.Toggle
          aria-controls={`offcanvasNavbar-expand-lg`}
          onClick={handleToggle}
        />
        <Navbar.Brand href="/home" className="navLogo">
          <img src={logo} />
        </Navbar.Brand>
        <Navbar.Offcanvas
          id={`offcanvasNavbar-expand-lg`}
          aria-labelledby={`offcanvasNavbarLabel-expand-lg`}
          placement="start"
          show={show}
          onHide={handleClose}
          className="customOffcanvasBelowHeader"
        >
          <Offcanvas.Header closeButton >
           
            <div className="offcanvasHeader">
              <div><a href="/profile"><img src={profileImg}/></a></div>
              <div>Andrew</div>

            </div>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Nav className="justify-content-center flex-grow-1 pe-3">
              {/* Add onClick to close sidebar when links are clicked */}
              <Nav.Link
                href="/home"
                className={activeMenu === "/home" ? "activeMenu" : "nav-link"}
              >
                Home
              </Nav.Link>
              <Nav.Link
                href="/about"
                className={activeMenu === "/about" ? "activeMenu" : "nav-link"}
              >
                About Us
              </Nav.Link>
              <Nav.Link
                href="/properties"
                className={
                  activeMenu === "/properties" ? "activeMenu" : "nav-link"
                }
              >
                Properties
              </Nav.Link>

              <Nav.Link
                href="/contact"
                className={
                  activeMenu === "/contact" ? "activeMenu" : "nav-link"
                }
              >
                Contact Us
              </Nav.Link>
            </Nav>
            <Nav className="profileContainer">
              <div>
                <a href="/profile">  <img src={profileImg}/></a>
              
              </div>
              <div>Andrew</div>
              <div><IoLogOutOutline /></div>
            </Nav>
          </Offcanvas.Body>
        </Navbar.Offcanvas>
      </Container>
    </Navbar>
  );
};
